export enum AskCopilotDataEventObject {
  PANEL = 'panel',
  FULL_SCREEN = 'full_screen',
  SKILLS_MENU = 'skills_menu',
  SKILL_CREATE = 'skill_create',
  SKILL_SAVE = 'skill_save',
  SKILL_DELETE = 'skill_delete',
  SKILL_EDIT = 'skill_edit',
  SKILL_TOGGLE_ACTIVE = 'skill_toggle_active',
  SKILL_PIN = 'skill_pin',
  SEARCH = 'search',
  SEARCH_RESULT = 'search_result',
  SESSION_RESET = 'session_reset',
  THREAD = 'thread',
  THREAD_PIN = 'thread_pin',
  THREAD_PIN_NAV = 'thread_pin_nav',
  PRESENTATION_MODE = 'presentation_mode',
  THREAD_DELETE = 'thread_delete',
  THREAD_RENAME = 'thread_rename',
  THREAD_ARCHIVE = 'thread_archive',
  THREAD_UNARCHIVE = 'thread_unarchive',
  THREAD_BULK_ARCHIVE = 'thread_bulk_archive',
  THREAD_BULK_DELETE = 'thread_bulk_delete',
  THREAD_BULK_MARK_READ = 'thread_bulk_mark_read',
  INPUT_SEND = 'input_send',
  INPUT_CANCEL = 'input_cancel',
  INPUT_NUDGE = 'input_nudge',
  INPUT_NUDGE_DISMISS = 'input_nudge_dismiss',
  INPUT_VOICE = 'input_voice',
  INPUT_CONTINUE_CONVERSATION = 'input_continue_conversation',
  CONCURRENT_STREAM = 'concurrent_stream',
  INTERACTION_USER_MESSAGE = 'interaction_user_message',
  INTERACTION_RESPONSE_MESSAGE = 'interaction_response_message',
  INTERACTION_RESPONSE_ERROR = 'interaction_response_error',
  INTERACTION_RESPONSE_MESSAGE_TOOLBAR_COPY = 'interaction_response_message_toolbar_copy',
  INTERACTION_USER_MESSAGE_TOOLBAR_COPY = 'interaction_user_message_toolbar_copy',
  INTERACTION_USER_MESSAGE_TOOLBAR_RETRY = 'interaction_user_message_toolbar_retry',
  INTERACTION_USER_MESSAGE_TOOLBAR_EDIT = 'interaction_user_message_toolbar_edit',
  INTERACTION_RESPONSE_MESSAGE_SOURCES_ITEM = 'interaction_response_message_sources_item',
  INTERACTION_SYSTEM_MESSAGE = 'interaction_system_message',
  INTERACTION_THINKING_STEPS = 'interaction_thinking_steps',
  FEEDBACK = 'feedback',
  FEEDBACK_FORM_SUBMIT = 'feedback_form_submit',
  LEGAL_MESSAGE = 'legal_message',
  LEGAL_MESSAGE_ACCEPT = 'legal_message_accept',
  ASK_USER_OPTION = 'ask_user_option',
  ASK_USER_CONFIRM = 'ask_user_confirm',
  APPROVAL_PROMPT = 'approval_prompt',
  APPROVAL_DECISION = 'approval_decision',
  QUOTE = 'quote',
  SUGGESTED_PROMPT = 'suggested_prompt',
  PROMPT_TEMPLATE = 'prompt_template',
  PROMPT_TEMPLATE_ADD_BUTTON = 'prompt_template_add_button',
  ARTIFACT = 'artifact',
  ANALYTICS_DRILLDOWN = 'analytics_drilldown',
  ANALYTICS_DRILLDOWN_CONVERSATION = 'analytics_drilldown_conversation',
  ENTRY_BUTTON_GLOW = 'entry_button_glow',
  COMMENT_BAR_MODE_SWITCH = 'comment_bar_mode_switch',
  COMMENT_BAR_MENTION = 'comment_bar_mention',
  ROUTINE_OUTPUT = 'routine_output',
  ROUTINES_MENU = 'routines_menu',
  ROUTINE_CREATE = 'routine_create',
  ROUTINE_FORM_NAME = 'routine_form_name',
  ROUTINE_FORM_SCHEDULE = 'routine_form_schedule',
  ROUTINE_FORM_INSTRUCTIONS = 'routine_form_instructions',
  ROUTINE_SAVE = 'routine_save',
  ROUTINE_FORM_CANCEL = 'routine_form_cancel',
  ROUTINE_RUN = 'routine_run',
  ROUTINE_TOGGLE_ACTIVE = 'routine_toggle_active',
  ROUTINE_EDIT = 'routine_edit',
  ROUTINE_DELETE = 'routine_delete',
  ROUTINE_TEMPLATE = 'routine_template',
  COLLAPSE_TO_SIDEBAR = 'collapse_to_sidebar',
  DAILY_BRIEF_GENERATE = 'daily_brief_generate',
}
